export const PRODUCTION = "bluebikedata.com";
export const DEV = "dev.bluebikedata.com";
 
export const API_URL =
  "https://qommev9951.execute-api.us-east-1.amazonaws.com/dev";
